import { Event, EventType } from "@markit/common.types";
import {
  getRequestTicketLabel,
  isEventExternalLink,
  isExternalEventbrite,
  isExternalGenericLink,
  isExternalShowclix,
  isProductSpecificType,
  isRequestTickets,
} from "@markit/common.utils";
import { Colors } from "../../../utils/colors";
import { useCallback } from "react";
import { Icon } from "@iconify/react";

type ProfileEventTimelineSubItemProps = {
  event: Event;
  condensedView?: boolean;
};

// To display the event details sub item box at the bottom of the ProfileEventTimelineCardItem or ProfileEventTimelineGridItem
// Displays the state such as "Request Required", "Linked Event"
const ProfileEventTimelineSubItem = (
  props: ProfileEventTimelineSubItemProps
) => {
  const { event, condensedView } = props;

  const renderItemContainer = useCallback(
    (title: string, color: string) =>
      condensedView ? (
        <span style={{ fontSize: 12, color: color }}>{title}</span>
      ) : (
        <div
          className="AlignedRowSelect"
          style={{
            gap: 5,
            justifyContent: "center",
            width: "min-content",
          }}
        >
          {isExternalGenericLink(event.eventType) ? (
            <Icon
              icon={
                event.eventType === EventType.GENERIC_LINK
                  ? "ion:document-text"
                  : "mdi:link-variant"
              }
              style={{ color: Colors.GRAY1 }}
              height={12}
            />
          ) : null}
          <span style={{ fontSize: 12, color: color, whiteSpace: "nowrap" }}>
            {title}
          </span>
        </div>
      ),
    [condensedView, event.eventType]
  );

  return isEventExternalLink(event.eventType)
    ? renderItemContainer(
        isExternalEventbrite(event.eventType)
          ? "Eventbrite"
          : isExternalShowclix(event.eventType)
          ? "Showclix"
          : event.eventType === EventType.GENERIC_LINK
          ? "Form"
          : event.eventType === EventType.GENERIC_LINK_NO_DATA
          ? "Link"
          : isProductSpecificType(event.eventType)
          ? event.eventType
          : "Linked Event",
        Colors.GRAY1
      )
    : isRequestTickets(event)
    ? renderItemContainer(getRequestTicketLabel(event.eventType), Colors.BLUE5)
    : event.eventType === EventType.WEBINAR
    ? renderItemContainer("Webinar", Colors.BLUE5)
    : null;
};

export default ProfileEventTimelineSubItem;
